
import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
/** Service to handle Spinner or page/data loading in application */
export class SpinnerService {

    /* #region Fields */
    private readonly _isVisible = signal<boolean | undefined>(undefined);
    private readonly _messages$ = toObservable(this._isVisible).pipe(
        filter((v): v is boolean => v !== undefined)
    );
    /* #endregion */

    constructor() { }

    /* #region Public Methods */
    /** Method to control/toggle spinner display */
    public show(show: boolean): void {
        this._isVisible.set(show);
        const sidenavContainer = document.getElementById('mat-sidenav-container-root');
        if (sidenavContainer) {
            if (show) {
                sidenavContainer.classList.add('backdrop-blur');
            } else {
                sidenavContainer.classList.remove('backdrop-blur');
            }
        }
    }

    /** Method to subscribe to spinner service to display spinner by status */
    public getMessage(): Observable<boolean> {
        return this._messages$;
    }
    /* #endregion */
}
